import { ConcreteEncodable } from "./ConcreteEncodable";

import { LifeCycleEventResponseImplEncoder } from "../../encoder/LifeCycleEventResponseImplEncoder";

import * as CubiqTS from "../../index";
import { LifeCycleEventResponse } from "../LifeCycleEventResponse";

export class LifeCycleEventResponseImpl
  extends ConcreteEncodable
  implements LifeCycleEventResponse
{
  public static enType: string = "com.bcdfx.model.event.LifeCycleEventResponseImpl";

  /*FID=1*/
  public receivedEvent: CubiqTS.OrderLifeCycleEvent | null = null;
  /*FID=2*/
  public responseType: CubiqTS.ResponseType;
  /*FID=3*/
  public text: string;
  /*FID=4*/
  public eventId: string;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = LifeCycleEventResponseImplEncoder.Instance;
    this.setEncodableType(LifeCycleEventResponseImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "LifeCycleEventResponseImpl[" +
      "receivedEvent=" +
      this.receivedEvent +
      "responseType=" +
      this.responseType +
      "text=" +
      this.text +
      "eventId=" +
      this.eventId +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
